module.exports = "../fonts/SFUIText-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIText-Regular.eot
// module id = 568
// module chunks = 0